import { format, parse } from 'date-fns';
import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';

const DATE_FORMAT = 'dd.MM.yyyy';
const UTC_ISO_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'";
const UTC_TIMEZONE = 'UTC';

const simpleToDate = (date: Date | string | null, fallbackToNow?: boolean) => {
  const fallback = fallbackToNow ? new Date() : null;

  return date ? new Date(date) : fallback;
};

export const parseFormat = (
  dateOrString: Date | string | null,
  dateFormat?: string | string[],
  fallbackToNow?: boolean
) => {
  const singleFormat = (currentDateFormat: string | undefined) =>
    currentDateFormat && typeof dateOrString === 'string'
      ? parse(dateOrString, currentDateFormat, new Date())
      : simpleToDate(dateOrString as Date, fallbackToNow);
  const fallbackFormattedValues = (Array.isArray(dateFormat) ? dateFormat : [dateFormat]).map(singleFormat);

  return fallbackFormattedValues?.filter(date => date && !isNaN(date.getTime())).find(Boolean) ?? null;
};

export const safeFormat = (date: Date | null, dateFormat?: string | string[]) => {
  const singleFormat = (currentDateFormat?: string) => {
    try {
      if (!date) return '';

      const hasTimezoneToken = currentDateFormat && /[XxOzZ]/.test(currentDateFormat);

      if (hasTimezoneToken) {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const utcDate = fromZonedTime(date!, timeZone);

        return formatInTimeZone(utcDate, UTC_TIMEZONE, UTC_ISO_FORMAT);
      }

      return format(date, currentDateFormat || DATE_FORMAT);
    } catch (e) {
      return '';
    }
  };
  const fallbackFormattedValues = (Array.isArray(dateFormat) ? dateFormat : [dateFormat]).map(singleFormat);

  return fallbackFormattedValues.find(Boolean)!;
};

export const prepareValue = (date: Date, dateFormat?: string[] | string) => {
  const isStringMode = !!dateFormat;

  if (!isStringMode) return date;

  return safeFormat(date, dateFormat);
};

export const prepareDisplayDate = (date: Date | string | null, dateFormat?: string | string[]) =>
  safeFormat(parseFormat(date, dateFormat, false));
